<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :before-close="cancel"
    width="1100px">
    <div class="scroll" style="font-size: 18px;letter-spacing: 1px;margin:20px 0;line-height: 45px;height: 700px;overflow-y: auto">
      <p style="text-align: center; margin-bottom: 50px">
        <span style="font-size: 24px;"><strong>2026年社会组织服务社会示范项目预算测算参考标准</strong></span>
      </p>
      <p style="text-indent: 2em; ">
        社会组织服务项目资金测算内容一般包括业务活动成本、管理费用、其他费用等三类费用。
      </p>
      <p style="text-indent: 2em;">
        <strong>一、业务活动成本</strong>
      </p>
      <p style="text-indent: 2em; ">
        业务活动成本是指为开展与社会组织服务项目直接相关的服务所发生的费用。原则上应按照与项目实施相关的具体工作逐项测算项目资金。
      </p>
      <p style="text-indent: 2em; ">
        <strong>（一）人力成本费用</strong>
      </p>
      <p style="text-indent: 2em; ">
        用于项目执行中发生的支付给承接主体投入项目的全职人员的费用。测算项目资金时应列明投入人员数量、投入工作量、人力成本测算标准及专业技术职称等。其中，投入工作量应按天或小时来计算。购买主体可根据人员学历层次、专业资质、工作经验等因素确定此项费用标准，可参照上一年度本市全口径城镇单位就业人员平均工资的80%—120%标准进行确定。
      </p>
      <p style="text-indent: 2em; ">
        <strong>（二）服务活动及培训（会议）相关费用</strong>
      </p>
      <p style="text-indent: 2em; ">
        用于直接对受益对象开展相应活动或培训（会议）所必须发生的各项费用，包括物资费、场地租赁费、交通费等。测算项目资金时应列明具体用途、规格、单价及数量等。培训（会议）费用应参照北京市党政机关事业单位培训、会议费相关标准执行。
      </p>
      <p style="text-indent: 2em; ">
        <strong>（三）劳务费</strong>
      </p>
      <p style="text-indent: 2em; ">
        用于项目执行中发生的支付给在承接主体无工资性收入的临时聘用人员的劳务性费用，包括专家费、临时聘用人员劳务费和志愿者补贴等。不得向在承接主体领取工资的在职工作人员支付劳务费，不得向政府部门工作人员支付劳务费。项目受益对象不得领取劳务费。
      </p>
      <p style="text-indent: 2em; ">
        测算项目资金时应列明人员数量、服务内容、投入工作量及劳务费标准，涉及专家费的还应列明专业技术职称。其中，投入工作量应按天或小时（课时）来计算。原则上，专家咨询费应参照《中央财政科研项目专家咨询费管理办法》（财科教〔2017〕128号）相关标准执行，专家讲课费应参照《北京市市级党政机关事业单位培训费管理办法》（京财预〔2017〕1389号）相关标准执行；临时聘用人员劳务费标准每人每天不超过300元；志愿者补贴标准每人每天不超过100元，发放志愿者补贴的不得再以报销形式列支餐费和交通费等支出。</p>
      <p style="text-indent: 2em; ">
        <strong>二、管理费用</strong>
      </p>
      <p style="text-indent: 2em; ">
        管理费用是指承接主体为组织和管理项目所发生的各项费用。购买主体可结合项目实际情况合理安排一定比例（不超过项目经费的8%）的管理费用。管理费用不得与其他项目支出重复列支相同内容。
      </p>
      <p style="text-indent: 2em; ">
        <strong>三、其他成本</strong>
      </p>
      <p style="text-indent: 2em; ">
        其他成本是指应在社会组织服务项目总预算中支付，但又无法归属到上述业务活动成本或管理费用中的费用，包括税费等。其中，税费应按照承接单位所属的纳税人类别据实核算。
      </p>
    </div>

  </el-dialog>
</template>

<script>

export default {
  name: "Dialog",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {

    }
  },
  created() {
  },
  methods: {
    cancel() {
      this.$emit('watchState', false)
    }
  },
  watch: {

  }
}
</script>

<style scoped lang="scss">

</style>
